import React from 'react';
import {Text} from '@inlet/react-pixi';
import {DisplayObjectList} from '../../components/DisplayObjectList';
import {CheatPluginView} from '../../CheatPluginView';
import {CheatInfoController} from './CheatInfoController';

export class CheatInfoView extends CheatPluginView<CheatInfoController> {
    protected getText(text: string): JSX.Element {
        return <Text key={text} text={text} style={{fontSize: 80, fill: 0xffffff}}/>;
    }

    protected getTexts(): JSX.Element[] {
        const infoString: JSX.Element[] = [];
        const {information} = this.controller;

        Object.entries(information).forEach(([key, value]) => {
            infoString.push(this.getText(`${key}:${value}`));
        });

        return infoString;
    }

    public render(): JSX.Element {
        return (
            <DisplayObjectList direction={'column'} gapBetweenChildren={20}>
                {...this.getTexts()}
            </DisplayObjectList>
        );
    }
}
